import { gql } from '@apollo/client';

export const UPSERT_ACCESS_GROUP_V2 = gql`
  mutation UpsertAccessGroupv2($input: AccessGroupCreateInputv2!) {
    upsertAccessGroupv2(input: $input) {
      ... on AccessGroupv2 {
        id
        parentId
        name
        description
        members {
          user {
            id
            firstName
            lastName
          }
          roles {
            id
            name
            description
            permissions
            owned {
              visibility
              clientId
            }
          }
          isSuperAgAdmin
        }
      }
      ... on AccessGroupv2InfoResult {
        message
        item
        isSuccess
      }
    }
  }
`;
